import React from "react";
import { WandSparkles } from "lucide-react";

const AiAssistantCard = () => {
  return (
    <div className="rounded-2xl border p-6 border-card bg-card w-full flex flex-col items-start gap-6">
      <p className="flex gap-1 justify-center items-center w-full text-sm font-semibold">
        <WandSparkles className="w-4 h-4"/>
        AI Assistant
      </p>
      <p className="text-card-foreground text-xs">
        Our AI will analyze your requirements and automatically match you with the best crew members and equipment from our marketplace.
      </p>
      <ul className="list-disc pl-6">
        <li className="text-card-foreground text-xs">Match crew based on skills & availability.</li>
        <li className="text-card-foreground text-xs">Suggest optimal equipment setup.</li>
        <li className="text-card-foreground text-xs">Generate timeline & budget estimate.</li>
      </ul>
    </div>
  )
}

export default AiAssistantCard;
